import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * "Back" navigation that falls back to a home/default route when there is no
 * prior in-app history entry — e.g. the page was opened directly via URL, a
 * fresh load, or a new tab. React Router tracks the history-stack position in
 * `window.history.state.idx`; idx === 0 (or absent) means this is the first
 * entry in the session, so a plain `navigate(-1)` would leave the app and land
 * on a blank page. In that case we go to `fallback` instead.
 */
export function useGoBack(fallback = '/') {
  const navigate = useNavigate()
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0
    if (idx > 0) {
      void navigate(-1)
    } else {
      void navigate(fallback, { replace: true })
    }
  }, [navigate, fallback])
}
